import SolicitacaoAdiantamento from './componentes/SolicitacaoAdiantamento.vue';
import SolicitacaoAdiantamentoLista from './componentes/SolicitacaoAdiantamentoLista.vue';
import SolicitacaoAdiantamentoForm from './componentes/SolicitacaoAdiantamentoForm.vue';
import SolicitacaoAdiantamentoDeclaracaoDespesas from './componentes/SolicitacaoAdiantamentoDeclaracaoDespesas.vue';
import SolicitacaoAdiantamentoRelatorio from './componentes/SolicitacaoAdiantamentoRelatorio.vue';

export default {
  path: '/solicitacao-adiantamento',
  component: SolicitacaoAdiantamento,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoAdiantamentoLista,
      name: 'solicitacao-adiantamento',
    },
    {
      path: 'nova',
      component: SolicitacaoAdiantamentoForm,
      name: 'solicitacao-adiantamento.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoAdiantamentoRelatorio,
      name: 'solicitacao-adiantamento.relatorio'
    },
    {
      path: ':id/declaracao-despesas',
      component: SolicitacaoAdiantamentoDeclaracaoDespesas,
      name: 'solicitacao-adiantamento.declaracao-despesas'
    },
    {
      path: ':idCript',
      component: SolicitacaoAdiantamentoForm,
      name: 'solicitacao-adiantamento.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-adiantamento/rotas.js